import SVG from "@Components/Icons/SVG";
export default class Upload extends SVG {
    path = [
        "M 24 36.6 c 0.5092 0 1.0183 -0.1909 1.4425 -0.5346 l 15.5575 -13.0654 v 37 c 0 2.4262 2 3.356 3.7418 3.24 s 3.2582 -0.884 3.2582 -2.884 v -37.356 l 14.4 12.6938 c 0.8062 0.7255 2.5418 2.4262 4.8 0.8138 c 1.0745 -0.9269 0.8828 -2.3131 0 -3.24 L 47 16 c -1.2 -1.08 -1.2 -1.08 -3.6 -1.08 L 22.8 32.28 c -0.8062 0.7255 -2.4 2.16 0 4.32 z M 77 66 V 80.4 C 77 82 77 82 75 82 H 14 C 12 82 12 82 12 80 V 66 C 12 62 5 62 5 66 V 84 c 0 3.1397 2.5457 5.7278 5.7278 5.7278 h 67.2722 c 3 0.2722 6 -1.7278 6 -5.7278 V 66 C 84 62 77 62 77 66",
    ];
    evenOdd = true;
}
